import { afterNextRender, Component, ElementRef, Input, Output, EventEmitter, signal, ViewChild } from '@angular/core';

@Component({
  selector: 'liberro-input',
  standalone: false,
  templateUrl: './liberro-input.component.html',
  styleUrl: './liberro-input.component.less'
})
export class LiberroInputComponent {
  @Input() public placeholder = '';
  @Input() public label = '';
  @Input() public value = '';
  @Input() public type: 'text' | 'password' = 'text';
  @Input() public passwordFeatures = false;
  @Input() public readonly = false;
  @Input() public suffixNzIcon = '';
  @Input() public suffixImgIcon = '';
  // TODO: Remove this when updating to Ant 20.4, which features nz-input-search element with correct suffix and behaviour
  @Input() public suffixIconBox = false;
  @Input() public customWidth = '';
  @Input() public customMargin = '';
  @Input() public autofocus = false;

  @Output() public suffixClick = new EventEmitter<string>();
  @Output() public valueChange = new EventEmitter<string>();

  @ViewChild('basicInputElement', { read: ElementRef }) private basicInputElement?: ElementRef<HTMLInputElement>;

  public passwordVisible = signal<boolean>(false);

  public constructor() {
    if (this.autofocus) {
      afterNextRender(() => {
          this.focus();
        });
    }
  }

  public togglePasswordVisibility(): void {
    this.passwordVisible.update(v => !v);
  }

  public onSuffixClick(): void {
    this.suffixClick.emit(this.value);
  }

  public onChange(term: string): void {
    this.valueChange.emit(term);
  }

  public focus(): void {

    if (this.basicInputElement?.nativeElement) {
      this.basicInputElement!.nativeElement.focus();
    }
  }
}
